import FilePickerAction from '../store/schema/FilePickerAction';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import { action } from 'satcheljs/lib/legacy';
import { FileProviderViewState } from 'owa-fileprovider-store';
import { getFileProviderInfo } from '../utils/fileProviderInfo';
import getMessageForComposeUniqueState from '../utils/getMessageForComposeUniqueState';
import {
    shouldAllowInsertAction,
    shouldDisableAttachButton,
    shouldDisableShareButton,
} from '../utils/shouldDisableActionButton';
import FilePickerActionMessageType, {
    actionMessageMap,
} from '../types/FilePickerActionMessageType';

function deleteFromArray(array: any[], item: any) {
    const index = array.indexOf(item);

    if (index !== -1) {
        array.splice(index, 1);
    }
}

function internalUpdateSupportedActions(
    possibleActions: FilePickerAction[],
    messages: string[],
    items: FileProviderItemViewState[] | File[],
    maxAllowedLocalFileSize: number,
    viewState: FilePickerPanelViewState,
    fileProviderName: string
) {
    const disableAttachButtonInfo = shouldDisableAttachButton(
        items,
        fileProviderName,
        maxAllowedLocalFileSize
    );
    if (disableAttachButtonInfo.shouldDisable) {
        deleteFromArray(possibleActions, FilePickerAction.Attach);
    }

    const composeUniqueStateMessage: string | null = viewState.filePickerActionsViewState
        .uploadConfiguration
        ? getMessageForComposeUniqueState(
              viewState.filePickerActionsViewState.uploadConfiguration.composeUniqueState,
              fileProviderName
          )
        : null;

    composeUniqueStateMessage && messages.push(composeUniqueStateMessage);

    if (disableAttachButtonInfo.message !== null) {
        messages = messages.concat(disableAttachButtonInfo.message);
    }

    if (shouldDisableShareButton(items)) {
        deleteFromArray(possibleActions, FilePickerAction.Share);
    }
    viewState.filePickerViewState.supportedActionsMessages = messages;
    viewState.filePickerViewState.supportedActions = possibleActions;
}

export const updateSupportedFilePickerActionsForProviderFiles = action(
    'updateSupportedFilePickerActionsForProviderFiles'
)(function updateSupportedFilePickerActionsForProviderFiles(
    items: FileProviderItemViewState[],
    maxAllowedLocalFileSize: number,
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerPanelViewState,
    supportsInsertLink?: boolean
) {
    if (items.length === 0) {
        viewState.filePickerViewState.supportedActions = [];
        return;
    }

    // Update the supported actions based on the provider
    const providerInfo = getFileProviderInfo(selectedFileProvider.type);
    const supportedProviderActions = providerInfo.getItemsSupportedActions(
        items as FileProviderItemViewState[],
        selectedFileProvider.allowFolderSharing,
        selectedFileProvider.name,
        supportsInsertLink
    );

    internalUpdateSupportedActions(
        supportedProviderActions.actions,
        supportedProviderActions.messages,
        items,
        maxAllowedLocalFileSize,
        viewState,
        selectedFileProvider.name
    );
});

export const updateSupportedFilePickerActionsForLocalFiles = action(
    'updateSupportedFilePickerActionsForLocalFiles'
)(function updateSupportedFilePickerActionsForLocalFiles(
    items: File[],
    maxAllowedLocalFileSize: number,
    viewState: FilePickerPanelViewState
) {
    let messages: string[] = [];

    if (items.length === 0) {
        viewState.filePickerViewState.supportedActionsMessages = [];
        viewState.filePickerViewState.supportedActions = [];
        return;
    }

    const supportedActions = [FilePickerAction.Attach, FilePickerAction.Share];

    if (shouldAllowInsertAction(items)) {
        supportedActions.push(FilePickerAction.Insert);
    }

    if (viewState.filePickerActionsViewState.uploadConfiguration?.uploadDisabled) {
        deleteFromArray(supportedActions, FilePickerAction.Share);
        messages.push(actionMessageMap[FilePickerActionMessageType.UploadToConsumerGroup]());
    }

    internalUpdateSupportedActions(
        supportedActions,
        messages,
        items,
        maxAllowedLocalFileSize,
        viewState,
        'OneDrive' /*TODO: Get default provider name here"*/
    );
});
